import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

import DateInput from 'schedule/common/modules/date/DateInput'
import closeIcon from 'resources/close_icon.png'
import DropDownInput from '../common/DropDownInput'
import Styles from '../common/Styles'

const Actions = ({ onCancelClicked, onSubmitClicked }) => {
  return (
    <div style={styles.actions}>
      <FlatButton
        label='Cancel'
        onTouchTap={onCancelClicked}/>
      <FlatButton
        primary={true}
        label='Submit'
        onTouchTap={onSubmitClicked}/>
    </div>
  )
}

Actions.propTypes = {
  onCancelClicked: PropTypes.func.isRequired,
  onSubmitClicked: PropTypes.func.isRequired
}

const Header = ({ onCloseRequested }) => {
  return (
    <div style={styles.header}>
      <div style={styles.heading}>
        Record a payment for this invoice
      </div>
      <div style={{ marginRight: 16 }}>
        <img src={closeIcon} title='Close' width={16}
          onClick={onCloseRequested}
          style={{ cursor: 'pointer' }} />
      </div>
    </div>
  )
}

Header.propTypes = {
  onCloseRequested: PropTypes.func.isRequired
}

export default class ManualPaymentDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    amountDue: PropTypes.number.isRequired,
    onSubmitPaymentClicked: PropTypes.func.isRequired,
    onCloseRequested: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = this.mapPropsToState(props)
  }

  mapPropsToState = props => ({
    input: {
      paymentDate: moment().toDate(),
      amountStr: `${props.amountDue.toFixed(2)}`,
      paymentMethod: 'none',
      notes: ''
    }
  })

  componentWillReceiveProps = nextProps => {
    if (nextProps.open) {
      this.setState(this.mapPropsToState(nextProps))
    }
  }

  handleInputValueChanged = (key, value) => {
    this.setState({
      validationErrorField: null,
      input: Object.assign(this.state.input, {
        [key]: value
      })
    })
  }

  validateInput = inputData => {
    if (!inputData.paymentDate) {
      return { errorField: 'payment_date' }
    }
    // Apply strict parsing to make sure the amount is the intended value.
    const parsedAmount = Number(inputData.amountStr)
    if (isNaN(parsedAmount)) {
      return { errorField: 'amountStr' }
    }
    if (parsedAmount < 0) {
      return { errorField: 'amountStr' }
    }
    inputData.amount = parsedAmount
    if (inputData.paymentMethod === 'none') {
      return { errorField: 'payment_method' }
    }
    return { success: true }
  }

  handleSubmitClicked = () => {
    const validationResult = this.validateInput(this.state.input)
    if (!validationResult.success) {
      this.setState({
        validationErrorField: validationResult.errorField
      })
    }
    else {
      this.props.onSubmitPaymentClicked(this.state.input)
    }
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Dialog open={this.props.open}
        onRequestClose={this.props.onCloseRequested}
        actions={
          <Actions
            onCancelClicked={this.props.onCloseRequested}
            onSubmitClicked={this.handleSubmitClicked} />
        }
        title={<Header onCloseRequested={this.props.onCloseRequested} />}
        bodyStyle={styles.dialogBody}
        contentStyle={styles.dialogContent}
        actionsContainerStyle={{ padding: 0 }}>
        <div style={styles.container}>
          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>Payment Date</div>
            <DateInput
              style={{ marginRight: 6 }}
              hintText='Payment Date'
              inline={true}
              value={this.state.input.paymentDate}
              onChange={(n, date) => this.handleInputValueChanged('paymentDate', date)}/>
            { this.state.validationErrorField === 'payment_date' &&
              <div style={Styles.validationError}>* Payment date value is required.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>Amount</div>
            <input style={Styles.fieldInput}
              value={this.state.input.amountStr}
              onChange={event => this.handleInputValueChanged('amountStr', event.target.value)} />
            { this.state.validationErrorField === 'amountStr' &&
              <div style={Styles.validationError}>* Please enter the payment amount.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>Payment method</div>
            <DropDownInput
              value={this.state.input.paymentMethod}
              list={PAYMENT_METHODS}
              onValueChanged={id => this.handleInputValueChanged('paymentMethod', id)}/>
            { this.state.validationErrorField === 'payment_method' &&
              <div style={Styles.validationError}>* Please specify the payment method.</div>
            }
          </div>

          <div style={styles.inputContainer}>
            <div style={Styles.fieldDisplay}>Memo/Notes</div>
            <textarea style={Styles.textareaInput}
              rows={7}
              value={this.state.input.notes}
              onChange={event => this.handleInputValueChanged('notes', event.target.value)} />
          </div>
        </div>
      </Dialog>
    )
  }

}

const PAYMENT_METHODS = [
  { id: 'none', name: 'Select a payment method' },
  { id: 'bank', name: 'Bank payment' },
  { id: 'cash', name: 'Cash' },
  { id: 'cheque', name: 'Cheque' },
  { id: 'credit_card', name: 'Credit Card' },
  { id: 'paypal', name: 'PayPal' },
  { id: 'other', name: 'Other' }
]

const styles = {
  container: {
    marginTop: 16,
    marginBottom: 16,
    marginLeft: 32,
    marginRight: 32
  },
  dialogContent: {
    borderRadius: 4,
    // This is a hack as there is a bug in Dialog's definition to properly
    // apply the border radius.
    overflow: 'auto',
    width: 400
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    borderRadius: 4
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 16
  },
  actions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 48,
    paddingRight: 16,
    backgroundColor: '#fafafa'
  },
  header: {
    display: 'flex',
    displayDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 48,
    backgroundColor: '#fafafa'
  },
  heading: {
    fontSize: 16,
    marginLeft: 16,
    color: '#212121'
  }
}



// WEBPACK FOOTER //
// ./src/billing/payments/ManualPaymentDialog.js